module.exports = __webpack_public_path__ + "static/media/status_Running_filter.ea1ce485.svg";